import { render, staticRenderFns } from "./enformzw.vue?vue&type=template&id=516a8240&scoped=true&"
import script from "./enformzw.vue?vue&type=script&lang=js&"
export * from "./enformzw.vue?vue&type=script&lang=js&"
import style0 from "./enformzw.vue?vue&type=style&index=0&id=516a8240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516a8240",
  null
  
)

export default component.exports